import type { FC } from "react";
import React from "react";
import { RecoverFormContainer } from "./components/recover_form_container/recover_form_container";

export const RecoverPage: FC = () => <RecoverFormContainer />;
